import { render, staticRenderFns } from "./LearningSync.vue?vue&type=template&id=a3d88f00&scoped=true&"
import script from "./LearningSync.vue?vue&type=script&lang=js&"
export * from "./LearningSync.vue?vue&type=script&lang=js&"
import style0 from "./LearningSync.vue?vue&type=style&index=0&id=a3d88f00&scoped=true&lang=css&"
import style1 from "./LearningSync.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d88f00",
  null
  
)

export default component.exports